export const Apiurl = {
    questionList: `finlabs_quiz/api/quiz/start`,
    questionSubmit: "finlabs_quiz/api/quiz/submit",
    leaderboardlist: "finlabs_quiz/api/users",
    signUpForm: "finlabs_quiz/api/users/registerAndScore",
    logInForm: "finlabs_quiz/api/users/loginAndScore",
    glossarySearch: `finlabs_quiz/api/glossary/search`,
    ebookCategory: "/finlabs_quiz/api/ebooks/category",
    riskAnalyzergetQuestionList: "/boi_risk_analyzer/getQuestionList",
    ebookViewAll: "/finlabs_quiz/api/ebooks/viewAllEbooks",
    ebookView: "finlabs_quiz/api/ebooks/details",
    ebookDownload: "finlabs_quiz/api/ebooks/download-pdf",


    searchByYear: '/finlabs_quiz/api/regulatory-records/search-by-year',
    searchByDepartment: '/finlabs_quiz/api/regulatory-records/search-by-department',
    search: '/finlabs_quiz/api/regulatory-records/search',
    viewAll: '/finlabs_quiz/api/regulatory-records/viewAll',
    view: '/finlabs_quiz/api/regulatory-records/view/'
};
